import React, { useEffect, useState, useRef, useMemo } from "react";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import AddButton from "../../components/AddButton/AddButton";
import "./SystemTab.css";
import { getDeviceLatestEOSversion, rebootDevice, upgradeDevicetoLatestEOSversion, cancelScheduledUpgrade } from "../../../../../actions/Users/authenticateInventory";
import { getDeviceLinkStatusData, getOpenEdgeSOftwareUpdateStatusData } from "../../../../../actions/Users/authenticateOpenEdgeService";
import { CONFIRM_DIALOG_TITLE } from "../../../../../config";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { compare } from "compare-versions";
import { DEVICE_LATEST_EOS_VERSION, GET_OPEN_EDGE_SOFTWARE_UPDATE, UPGRADE_DEVICE_TO_LATEST_EOS_VERSION } from "../../../../../actions/types";
import _ from "lodash";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import UploadConfig from "./UploadConfig";
import { DEFAULT_DATE_FORMAT } from "../../../../../utils/constants";
import { convertDateTimeIntoTimezone } from "../../../../../utils/util";
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import InfoBar from "../../components/InfoBar/InfoBar";
import { toast } from "react-toastify";
import FirmwareUpdateStatus from "../../components/FirmwareUpdateProgress/FirmwareUpdateProgress";
import moment, { Moment } from "moment-timezone";

interface Props {
  row: object;
  isValidTier: boolean;
  deviceName: string | undefined;
  getDeviceLatestEOSversion;
  deviceLatestEosVersion;
  rebootDevice;
  upgradeDevicetoLatestEOSversion;
  userTimezone: any;
  topology: boolean;
  getOpenEdgeSOftwareUpdateStatusData;
  getSOftwareUpdateStatus;
  getSoftwareUpdate;
  refreshIconClicked: boolean;
  getDeviceLinkStatusData;
  deviceLinkStatusLoading;
  setOpen: () => void;
  deviceInfo?: string;
  upgradeToLatestDeviceLoading: boolean;
}

const SystemTab: React.FC<Props> = (props) => {
  const { row, isValidTier, deviceName, getDeviceLatestEOSversion, deviceLatestEosVersion, rebootDevice, upgradeDevicetoLatestEOSversion, userTimezone, topology, getOpenEdgeSOftwareUpdateStatusData, getSOftwareUpdateStatus, getSoftwareUpdate, refreshIconClicked, getDeviceLinkStatusData, deviceLinkStatusLoading, setOpen, deviceInfo, upgradeToLatestDeviceLoading } = props;

  const [selectedDeviceLatestEosVersion, setSelectedDeviceLatestEosVersion] = useState<any>("Fetching data...");
  const [isLatestEosAvailable, setIsLatestEosAvailable] = useState(false)
  const dispatch = useDispatch();
  let fetchingData = "Fetching data...";
  const KONNECT_STATUS_CONNECTED = "STATUS_CONNECTED";
  const [shouldPollStatus, setShouldPollStatus] = useState(false);
  const pollingRef = useRef<any>(null);
  const tableSoftwareVersion = !_.isEmpty(row['current_EOS_version']) ? row['current_EOS_version'].toLowerCase().startsWith("v") ? row['current_EOS_version'] : "v" + row['current_EOS_version'] : "";
  const [softwareVersion, setSoftwareVersion] = useState(tableSoftwareVersion);
  const [isUpgradeFailed, setIsUpgradeFailed] = useState(false)
  const [isUpgradeScheduled, setIsUpgradeScheduled] = useState<any>({scheduled: false, scheduledTime: ''});
  const [cancelUpgrade, setCancelUpgrade] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [noticePopup, setNoticePopup] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: {},
  });
  const [upgradeStatus, setUpgradeStatus] = useState('Update Software');
  const [bannerOpen, setBannerOpen] = useState(false);
  const [statusHistory, setStatusHistory] = useState<any>({});
  const validTimeZone = userTimezone?.split(" - ")?.[0] || "UTC";
  const timeZone = userTimezone?.split(" - ")?.[1] || "UTC";
  const getNow = (): Moment => {
    return moment.tz(validTimeZone)
  };
  const [selectedDateTime, setSelectedDateTime] = useState<any>(getNow());
  const [saveText, setSaveText] = useState("Update");
  const [currentStep, setCurrentStep] = useState(0);
  const [downloadProgress, setDownloadProgress] = useState(0);

  

  useEffect(() => {
      if (!selectedDateTime) {
        setSaveText("Update");
        return;
      }

      const now = getNow();

      let selectedDT: Moment;

      if (moment.isMoment(selectedDateTime)) {
        selectedDT = selectedDateTime;
      } else if (typeof selectedDateTime === "string") {
        selectedDT = moment.tz(selectedDateTime, "MM-DD-YYYY, HH:mm", validTimeZone ?? "UTC");
      } else {
        setSaveText("Update");
        return;
      }

      setSaveText(selectedDT.isAfter(now) ? "Schedule Update" : "Update");
  }, [selectedDateTime, validTimeZone]);


  useEffect(() => {
    if (openPopup) setSelectedDateTime(getNow());
  }, [openPopup]);

  const handleReboot = () => {
    setConfirmDialog({
      isOpen: true,
      title: CONFIRM_DIALOG_TITLE,
      subTitle: "Confirm to Reboot the device " + deviceName + " ?",
      onConfirm: () => {
        rebootDevice(row["k4Id"], row["deviceId"]);
      },
    })
  };
  const handleUpdate = () => {
      setIsUpgradeFailed(false)
      setOpenPopup(true);
  };

  const getScheduledTimeISO = () => {
    if (!selectedDateTime) return null;

    if (moment.isMoment(selectedDateTime)) {
      return selectedDateTime.toISOString();
    }

    if (selectedDateTime instanceof Date) {
      return selectedDateTime.toISOString();
    }

    if (typeof selectedDateTime === "string") {
      const [datePart, timePart] = selectedDateTime.split(", ");
      if (!datePart || !timePart) return null;

      const [mm, dd, yyyy] = datePart.split("-");
      const [hh, min] = timePart.split(":");

      const dateObj = new Date(
        Number(yyyy),
        Number(mm) - 1,
        Number(dd),
        Number(hh),
        Number(min)
      );
      return dateObj.toISOString();
    }

    return null;
  };

  const confirmUpgradeSoftware = () => {
    if (row['konnect_status'] !== KONNECT_STATUS_CONNECTED) return;

    if (saveText === "Schedule Update") {
      const scheduled_time = getScheduledTimeISO();
      console.log('scheduled_time',scheduled_time)
      upgradeDevicetoLatestEOSversion(row['k4Id'], row['deviceId'], scheduled_time);
    } else if(saveText === "Update") {
      upgradeDevicetoLatestEOSversion(row['k4Id'], row['deviceId']);
    }
    setNoticePopup(false);
  };

  useEffect(() => {
    if (!_.isEmpty(row['deviceId'])) {
      getDeviceLatestEOSversion(row['deviceId']);
      getOpenEdgeSOftwareUpdateStatusData(row['k4Id'], row['deviceId']);
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(row['deviceId'])) {
      if (shouldPollStatus) {
        const intervalId = setInterval(() => {
          getOpenEdgeSOftwareUpdateStatusData(row['k4Id'], row['deviceId']);
        }, 30000);

        pollingRef.current = intervalId;

        return () => {
          if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
          }
        };
      }
    }
  }, [shouldPollStatus]);

  useEffect(() => {
    if (!_.isEmpty(deviceLatestEosVersion)) {
      if (!_.isEmpty(deviceLatestEosVersion?.data)) {
        let eosVersion = deviceLatestEosVersion?.data?.app_version;
        if (!_.isEmpty(eosVersion)) {
          eosVersion = eosVersion.split("~")[0]
          eosVersion = eosVersion.toLowerCase().startsWith("v") ? eosVersion : "v" + eosVersion
          setSelectedDeviceLatestEosVersion(eosVersion)
        }
      }
      dispatch({ type: DEVICE_LATEST_EOS_VERSION, payload: {} })
    }
  }, [deviceLatestEosVersion])

  useEffect(() => {
    if (!_.isEmpty(selectedDeviceLatestEosVersion)) {
      try {
        if (selectedDeviceLatestEosVersion != fetchingData) {
          const current = softwareVersion.includes('~') ? softwareVersion.split('~')[0] : softwareVersion;
          const isLatestAvailable = compare(current, selectedDeviceLatestEosVersion, "<");
          const isCurrentHigher = compare(current, selectedDeviceLatestEosVersion, ">");
          setIsLatestEosAvailable(isLatestAvailable);
          setBannerOpen(!isCurrentHigher && !isLatestAvailable);
        }
      } catch (e) {
        console.log("Invalid EOS version format, current:", softwareVersion, " latest:", selectedDeviceLatestEosVersion)
      }
    }
  }, [selectedDeviceLatestEosVersion, softwareVersion])

  const isRetryActive = () => {
    const stored = localStorage.getItem("upgradeInProgress");
    return stored && (Date.now() - Number(stored) < 30000);
  };

  useEffect(() => {
    if(!_.isEmpty(getSoftwareUpdate)) {
      // setShouldPollStatus(true);
      if(saveText === "Schedule Update") {
        const scheduled_time = getScheduledTimeISO();
        setUpgradeStatus('Upgrade Scheduled');
  
        setIsUpgradeScheduled({ scheduled: true, scheduledTime: scheduled_time });
        localStorage.setItem("scheduledUpgrade", "true");
        localStorage.setItem("upgradeInProgress", String(Date.now()));
      } else if(saveText === "Update") {
        // localStorage.setItem("upgradeInProgress", String(Date.now()));
        // setUpgradeStatus('Upgrade Initiated')
      }
      getOpenEdgeSOftwareUpdateStatusData(row['k4Id'], row['deviceId']);
      dispatch({ type: UPGRADE_DEVICE_TO_LATEST_EOS_VERSION, payload: {} })
    }
  }, [getSoftwareUpdate])

  const step1Statuses = [
    "request received",
    "download initiated",
    "download inprogress"
  ];

  const step2Statuses = [
    "installation inprogress"
  ];

  const getStepNumber = (status: string) => {
    if (!status) return 0;
    const lowerStatus = status.toLowerCase();

    if (step1Statuses.some(s => lowerStatus.includes(s))) return 1;
    if (step2Statuses.some(s => lowerStatus.includes(s))) return 2;

    return 0;
  };

  const getAppProgress = (response) => {
    try {
      const history = response?.status_history
        ? JSON.parse(response.status_history)
        : {};

      const appPercent = parseFloat(history?.download?.["app percentage"]) || 0;
      return Math.round(appPercent);
    } catch (err) {
      console.error("Error parsing app percentage:", err);
      return 0;
    }
  };

  useEffect(() => {
    if (!_.isEmpty(getSOftwareUpdateStatus)) {
      const response = getSOftwareUpdateStatus.hasOwnProperty('data') ? getSOftwareUpdateStatus.data?.[0] : {};
      setStatusHistory(response?.status_history ? JSON.parse(response?.status_history) : {});

      const status = response?.status?.toLowerCase() || "";
      const currentStep = getStepNumber(status);
      setCurrentStep(currentStep);

      let progressPercent = 0;
      if (status?.includes("download inprogress")) {
        progressPercent = getAppProgress(response);
      }
      setDownloadProgress(progressPercent);

      if (localStorage?.getItem('scheduledUpgrade') == 'true') {
        setUpgradeStatus('Upgrade Scheduled');
        setShouldPollStatus(true);
      }
      if (response?.is_scheduled_action && response?.scheduled_time != '' && response?.status == 'scheduled') {
        setIsUpgradeScheduled({ scheduled: response?.is_scheduled_action, scheduledTime: response?.scheduled_time });
        localStorage.removeItem("scheduledUpgrade");
        setShouldPollStatus(true);
        setUpgradeStatus('Upgrade Scheduled');
      } else if (localStorage?.getItem('scheduledUpgrade') != 'true' && (response?.status === "EOS up to date" || response?.status === "upgraded" || response?.status === "failed")) {
        if (response?.status === "failed") {
          setIsUpgradeFailed(true);
        } else if (response?.status == 'upgraded' || response?.status == 'EOS up to date') {
          setSoftwareVersion(response?.current_sw_version);
          setUpgradeStatus(response?.status);
        }

        // if (isRetryActive()) {
        //   setShouldPollStatus(true);
        //   setUpgradeStatus('Upgrade Initiated');
        //   return;
        // }

        if (pollingRef.current) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
        setShouldPollStatus(false);
        setIsUpgradeScheduled({ scheduled: false });
        dispatch({ type: GET_OPEN_EDGE_SOFTWARE_UPDATE, payload: {} })
        localStorage.removeItem("upgradeInProgress");
        localStorage.removeItem("scheduledUpgrade");
      } else if (response?.status === 'request received' || response?.status === "download initiated" || response?.status === 'download inprogress' || response?.status === "installation inprogress") {
        setShouldPollStatus(true);
        setIsUpgradeScheduled({ scheduled: false });
        localStorage.removeItem("scheduledUpgrade");
        setUpgradeStatus(response?.status)
      }
    }
  }, [getSOftwareUpdateStatus]);

  useEffect(() => {
    if (refreshIconClicked) {
      getDeviceLinkStatusData(row['k4Id'], row['deviceId']);
    }
  }, [refreshIconClicked])

  const formatScheduledTime = (utcString: string) => {
    if (!utcString) return "";
    const date = new Date(utcString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: validTimeZone,
    }).format(date);
  };

  const getUpgradeMessage = () => {
    if (cancelUpgrade) {
      return (
        <>
          <div className="upgrade-confirm-message">
            <strong>Cancel or Reschedule Update</strong>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
              <li>Cancel or Reschedule Update Cancel Update stops the scheduled update.</li>
              <li>Change Schedule sets a new update time.</li>
              <li>The device reboots only at the new time.</li>
              <li>Network and sessions stay unaffected until then.</li>
            </ul>
          </div>
        </>
      );
    }

    if (saveText == 'Schedule Update') {
      return (
        <>
          <div className="upgrade-confirm-message">
            <strong>Schedule an update to the software on this device.</strong>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
              <li>The device will reboot at the scheduled time.</li>
              <li>Network connectivity will be lost during the update process.</li>
              <li>Active sessions and traffic routing will be interrupted.</li>
            </ul>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="upgrade-confirm-message">
          <strong>You're about to update the software on this device.</strong>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
            <li>The device will automatically reboot.</li>
            <li>Network connectivity will be lost during the update process.</li>
            <li>Active sessions and traffic routing will be interrupted.</li>
          </ul>
        </div>
      </>
    );
  };


  const handleCancelScheduledUpgrade = async () => {
    const edgeTransactionId = getSOftwareUpdateStatus?.data?.[0]?.edge_transaction_id || row['edge_transaction_id'] || '';
    if (!row['k4Id'] || !row['deviceId'] || !edgeTransactionId) {
      setNoticePopup(false);
      setCancelUpgrade(false);
      toast.error('Missing required info to cancel scheduled upgrade');
      return;
    }
    const apiCall = cancelScheduledUpgrade(row['k4Id'], row['deviceId'], edgeTransactionId);
    const res: any = await dispatch(apiCall);
    if (res && typeof res === 'object' && res.hasOwnProperty('success')) {
      if (res.success) {
        setIsUpgradeScheduled({ scheduled: false, scheduledTime: '' });
        setUpgradeStatus('Update Software');
        setCancelUpgrade(false);
        setNoticePopup(false);
        localStorage.removeItem('scheduledUpgrade');
        localStorage.removeItem('upgradeInProgress');
        setShouldPollStatus(false); // Stop polling
        if (pollingRef.current) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
      }
    }
  }

  const handleChangeSchedule = () => {
    setOpenPopup(true);
    setNoticePopup(false);
    setSaveText('Schedule Update');
    setCancelUpgrade(false);
  }

  return (
    <div className="system-tab-grid-container">
      <div className="system-tab-grid">
        {/* Row 1 */}
        <LabelValueDisplay label="Device Name" value={deviceName} />
        <LabelValueDisplay label="System Uptime" value={convertDateTimeIntoTimezone(row['uptime_date'], userTimezone, DEFAULT_DATE_FORMAT)} />
        <LabelValueDisplay label="Konnect Status" value={row['konnect_status'] == 'STATUS_CONNECTED' ? 'Online' : row['konnect_status'] == 'STATUS_NOT_CONNECTED' ? 'Offline' : 'Unknown'} valueType='status' labelType='konnectStatusWithTitle' />
        <AddButton onAddClick={handleReboot} addLabel="Reboot Device" maxWidth="220px" />

        {/* Row 2 */}
        <LabelValueDisplay label="Device Model" value={row['productType']} />
        <LabelValueDisplay label="Latest Available Software" value={selectedDeviceLatestEosVersion} />
        <LabelValueDisplay label="Current Software Version" value={isUpgradeFailed ? softwareVersion.includes('~') ? softwareVersion?.split('~')?.[0] : softwareVersion : `${softwareVersion.includes('~') ? softwareVersion?.split('~')?.[0] : softwareVersion}`} />
        {shouldPollStatus ? <button className="inprogress-button">
          <span className="progress-fill" style={{ width: upgradeStatus === 'Update Software' ? '100%' : '72%' }}></span>
          <span className="progress-text">{upgradeStatus}</span>
        </button>
          : <AddButton onAddClick={handleUpdate} addLabel={isUpgradeFailed ? "Retry Update" : 'Update Software'} maxWidth="220px" disabled={!(row['konnect_status'] === KONNECT_STATUS_CONNECTED) || !isLatestEosAvailable || isUpgradeScheduled?.scheduled || localStorage?.getItem('scheduledUpgrade') == 'true'} />}
      </div>
       {(localStorage?.getItem('scheduledUpgrade') == 'true' || isUpgradeScheduled?.scheduled) && <InfoBar
          message={`The Software update has been scheduled on ${formatScheduledTime(isUpgradeScheduled?.scheduledTime)}`}
          buttonLabel="Cancel Update"
          onButtonClick={() => {setNoticePopup(true); setCancelUpgrade(true)}}
        />}
      {shouldPollStatus && saveText == 'Update' && !(localStorage?.getItem('scheduledUpgrade') == 'true' || isUpgradeScheduled?.scheduled) && <FirmwareUpdateStatus
        status="progress"
        version="1.1.0.200"
        currentStep={currentStep}
        totalSteps={2}
        progress={downloadProgress}
        statusText={upgradeStatus}
      />}
      {bannerOpen && !_.isEmpty(statusHistory) && <FirmwareUpdateStatus
        status="completed"
        onClose={() => setBannerOpen(false)}
      />}

      {deviceInfo != 'ap' && <UploadConfig row={row} deviceName={deviceName} setConfirmDialog={setConfirmDialog} setOpen={setOpen} />}

      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      <AddEditInterfaceModal
        open={openPopup}
        onClose={() => { setOpenPopup(false) }}
        onSave={() => { setNoticePopup(true); setOpenPopup(false) }}
        saveText={saveText}
        disableSave={!selectedDateTime}
        title={'Action'}
        layout={[
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="Current version"
                    value={softwareVersion.includes('~') ? softwareVersion?.split('~')?.[0] : softwareVersion}
                  />
                ),
                gridSize: 6,
              },
            ],
          },
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="Update version"
                    value={selectedDeviceLatestEosVersion}
                  />
                ),
                gridSize: 6,
              },
            ],
          },
          {
            columns: [
              {
                component: (
                  <>
                    {saveText == 'Update' ? (
                      <LabelValueDisplay
                        label="Update Time"
                        isCurrentDateTime={true}
                        timeZone={timeZone}
                        validTimeZone={validTimeZone}
                        value="Now"
                        onChange={() => setSaveText('Schedule Update')}
                      />
                    ) : (
                      <LabelValueDisplay
                        label="Update Time"
                        isDateTime={true}
                        timeZone={timeZone}
                        validTimeZone={validTimeZone}
                        selectedDateTime={selectedDateTime}
                        setSelectedDateTime={setSelectedDateTime}
                        placeholder="MM/DD/YYYY HH:MM"
                      />
                    )}
                  </>
                ),
                gridSize: 12,
              },
            ],
          },
        ]}
      />
      <AddEditInterfaceModal
        open={noticePopup}
        onClose={() => { setNoticePopup(false) }}
        onSave={cancelUpgrade ? handleCancelScheduledUpgrade : confirmUpgradeSoftware}
        saveText={cancelUpgrade ? 'Cancel Update' : saveText == 'Schedule Update' ? 'Schedule Update' : 'Update Now'}
        title={'Action'}
        cancelText={cancelUpgrade ? 'Change Schedule' : 'Cancel'}
        onCancelSave={handleChangeSchedule}
        layout={[
          {
            columns: [
              {
                component: getUpgradeMessage(),
                gridSize: 12,
              },
            ],
          }
        ]}
      />
      {deviceLinkStatusLoading || upgradeToLatestDeviceLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  deviceLatestEosVersion: state.authReducer.deviceLatestEosVersion,
  userTimezone: state.authReducer.userTimezone,
  getSoftwareUpdate: state.authReducer.upgradeToLatestDevice,
  getSOftwareUpdateStatus: state.authReducer.getOpenEdgeSoftwareUpdateStatus,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
  upgradeToLatestDeviceLoading: state.authReducer.upgradeToLatestDeviceLoading,
});

export default withRouter(
  connect(mapStateToProps, {
    getDeviceLatestEOSversion, rebootDevice, upgradeDevicetoLatestEOSversion, getOpenEdgeSOftwareUpdateStatusData, getDeviceLinkStatusData
  })(SystemTab)
);
